<template>
    <div class="mod-config">
        <div style="border-radius: 30px">
            <el-form :inline="true" size="mini" :model="dataForm" @keyup.enter.native="queryHandle()">
                <el-row>
                    <el-form-item label="产品名称">
                        <el-input size="mini" v-model="dataForm.productName" placeholder="产品名称" clearable style="width: 200px">
                            <template slot="append">
                                <el-checkbox v-model="dataForm.productNameFuzzy">模糊</el-checkbox>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="mini" @click="queryHandle()" icon="el-icon-search">查询</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                      :height="style.gridStyle.height"
                      border :header-cell-style="{background:'#f5f5f5'}">
                <el-table-column header-align="center" align="center" label="序号" width="55">
                    <template slot-scope="scope">
                        {{ scope.row.rowid }}
                    </template>
                </el-table-column>
                <el-table-column prop="productName" header-align="center" align="left" label="产品名称" min-width="150">
                </el-table-column>
                <el-table-column prop="supportingCompanyName" header-align="center" align="left" label="配套公司" min-width="150">
                    <template slot-scope="scope">
                        {{ scope.row.supportingCompanyName || '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="productCategory" header-align="center" align="center" label="产品类别" min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.productCategory || '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="venderCode" header-align="center" align="center" label="供应商代码" min-width="120">
                    <template slot-scope="scope">
                        {{ scope.row.venderCode || '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="venderName" header-align="center" align="left" label="供应商名称" min-width="200">
                </el-table-column>
                <el-table-column prop="supplierLevel" header-align="center" align="center" label="供应商类型" min-width="120">
                    <template slot-scope="scope">
                        {{ supplierLevelMap[scope.row.supplierLevel] || '' }}
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                           :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                           layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import { listSupplierByProductName } from '@/controller/supplier'

    export default {
        name: 'productSearchIndex',
        data() {
            return {
                dataForm: {
                    productName: '',
                    productNameFuzzy: true,
                },
                supplierLevelMap: {
                    0: '潜在供应商',
                    1: '合格供应商',
                    2: '一次性供应商',
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                style: {
                    gridStyle: {
                        height: (parseInt(document.documentElement['clientHeight']) - 255) + "px"
                    }
                },
            }
        },
        activated() {
            this.getDataList()
        },
        methods: {
            queryHandle() {
                this.pageIndex = 1
                this.getDataList()
            },
            getDataList() {
                this.dataListLoading = true
                listSupplierByProductName({
                    'pageNo': this.pageIndex,
                    'pageSize': this.pageSize,
                    'productName': this.dataForm.productName,
                    'productNameFuzzy': this.dataForm.productNameFuzzy,
                }).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                }).catch((e) => {
                    console.log(e)
                }).finally(() => {
                    this.dataListLoading = false
                })
            },
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            rowClassName({ row, rowIndex }) {
                row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
            },
        }
    }
</script>
